window.addEventListener('load', function(){
  ratingSnippet("ruk_rating_snippet", {
    store: "xbyx.de",
    mode: "default",
    color: "#f3c200",
    linebreak: false,
    lang: "de-in",
    usePolaris: true,
    showEmptyStars: false,
  });
  var snippets = document.querySelectorAll(".ruk_rating_snippet");
  var reviewWidget = document.querySelector("reviewsio-product-reviews-widget");
  snippets.forEach(snippet => {
    snippet.onclick = function(e) {
      if(snippet.getAttribute("href")){
        // console.log("snippet has href", snippet);
        e.preventDefault();
        window.location.href = snippet.getAttribute("href");
      }
      else{
        if(reviewWidget && snippet) {
          // console.log("snippet has widget", snippet);
          // reviewWidget.scrollIntoView({ block: 'nearest',  behavior: 'smooth' });
          let scroll_by_value = reviewWidget.offsetTop - document.querySelector("#SiteHeader").offsetHeight - document.querySelector("#shopify-section-announcement").offsetHeight  - 60;
          window.scrollTo({ left: 0, top: scroll_by_value, behavior: "smooth"});
        }
      }
    }
  });
  if(window.location.href.includes("#reviewsio_polaris")){
    if(reviewWidget) {
      let scroll_by_value = reviewWidget.offsetTop - document.querySelector("#SiteHeader").offsetHeight - document.querySelector("#shopify-section-announcement").offsetHeight  - 60;
      window.scrollTo({ left: 0, top: scroll_by_value, behavior: "smooth"});
    }
  }
  if(reviewWidget) {
    reviewWidgetComments();
    document.querySelectorAll(".R-PaginationControls__item").forEach(function (element) {
      element.addEventListener('click', function () {
        console.log("click on page");
        reviewWidgetComments();
      });
    });
  }
});

function reviewWidgetComments() {
  setTimeout(() => {
    document.querySelectorAll(".R-ContentList__item").forEach(function (element2) {
      element2.closest(".R-ContentList__item").style.display = "flex";
    });
    document.querySelectorAll(".ElementsWidget-prefix .R-TextBody--xs *").forEach(function (element2) {
      console.log("element2.innerText:",element2.innerText);
      if(element2.innerText == "Kunde hat keine Kommentare hinterlassen."){
        element2.style.display = "none";
        element2.closest(".R-ContentList__item").style.display = "none";
      }
    });
  }, 500);
}

document.addEventListener("variant:change", function(event) {
  var variant = event.detail.variant;
  console.log("variant changed:", variant);
  ratingSnippet("ruk_rating_snippet", {
    store: "xbyx.de",
    mode: "default",
    color: "#f3c200",
    linebreak: false,
    lang: "de-in",
    usePolaris: true,
    showEmptyStars: false,
  });
  let money_datalayer_format = theme.settings.moneyFormat.replace('_with_comma_separator','').replace(' €','');
  let variant_price = theme.Currency.formatMoney(variant.price, money_datalayer_format);
  gtag('event','view_item', {
    'value': variant_price,
    'items': [
      {
        'id': "shopify_DE_" + variant.featured_image?.product_id + '_' + variant.id,
        'google_business_vertical': 'retail'
      }
    ]
  });
})

document.addEventListener("DOMContentLoaded", function(){
  var grid_msnry = document.querySelector('.masonry_wrapper');
  // init with selector
  var msnry = new Masonry('.masonry_wrapper', {
    // options...
    itemSelector: '.masonry_item',
    horizontalOrder: true
  });

  if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
    const hightItemOne = document.querySelectorAll(".community_section_wrapper .masonry_item")[0].getBoundingClientRect().height
    const hightItemTwo = document.querySelectorAll(".community_section_wrapper .masonry_item")[1].getBoundingClientRect().height
    const hightItemThree = document.querySelectorAll(".community_section_wrapper .masonry_item")[2].getBoundingClientRect().height
    grid_msnry.style.maxHeight = hightItemOne + hightItemTwo + hightItemThree + 40 + "px";
  }

  var read_btns = document.querySelectorAll(".readBtns");
  read_btns.forEach(btn => {
    btn.addEventListener("click", function(){
      let parent = btn.closest(".community_section");
      if(btn.getAttribute("id") == "readMore"){
        parent.classList.remove("read_more_active");
        if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
          grid_msnry.style.maxHeight = "unset";       
        }
      }else{
        parent.classList.add("read_more_active");
        parent.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        if(window.innerWidth <= 590 && grid_msnry != null && document.querySelectorAll(".community_section_wrapper .masonry_item")[4] != null){
          grid_msnry.style.maxHeight = ((document.querySelectorAll(".community_section_wrapper .masonry_item")[4].getBoundingClientRect().top - document.querySelector(".community_section_wrapper").getBoundingClientRect().top) - document.querySelectorAll(".community_section_wrapper .masonry_item")[4].getBoundingClientRect().height - 120) + "px";
        }
      }
    });  
  });
});

function removeItems(items,updatedItems,redirectToCheckout){
  let update = {};

  items.forEach(num => {
    update[num] = 0;
  });
  updatedItems.forEach(update_num => {
    update[update_num] = 1;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
    body: JSON.stringify({
        updates: update
    })
  })
  .then(response => response.json())
  .then(function(response){
    document.dispatchEvent(new CustomEvent('cart:build'));
    window.ignored_gift_popup = "false";
    if(redirectToCheckout){
      window.location.href = '/checkout';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function recheckCartItems(redirectToCheckout) {
  let arrayItems = [];
  let updatedItems = [];
  let shakerProductID = window.gift?.giftProduct;
  let giftProductID = window.cart_gift?.product_id;
  console.log("shakerProductID ", shakerProductID);
  console.log("giftProductID ", giftProductID);

  fetch("/cart.js")
  .then(response=> response.json())
  .then(response => {
    console.log("find items that need to be deleted ", response.items);
    let found_gift_product = false;
    response.items.forEach( item => {
      console.log("item: ", item.title);
      if (item.properties["_bundle_set"] && !item.properties["_bundle_items"]){
        arrayItems.push(item.id);
      }
      if(giftProductID != null){
        if( item.product_id == giftProductID ){
          if( found_gift_product ){
            console.log("it's already found before so remove this variant");
            arrayItems.push(item.id);
          }else{
            if( item.quantity > 1){
              console.log("update gift to be 1 only");
              updatedItems.push(item.id);
            }
            found_gift_product = true;
          }
        }
      }
      if(shakerProductID != null){
        if( item.id == shakerProductID && item.quantity > 1 ){
          console.log("update shaker to be 1 only");
          updatedItems.push(item.id);
        }
      }
    })
  })
  .then( () => {
    if(arrayItems || updatedItems) removeItems(arrayItems,updatedItems,redirectToCheckout);
  })
}

window.addEventListener('load', function(e){
    recheckCartItems(false);
    let checkoutbtns = document.querySelectorAll(".btn.cart__checkout_custom");
    if(checkoutbtns.length > 0){
      checkoutbtns.forEach(checkoutbtn => {
        checkoutbtn.addEventListener('click', function(e) {
          console.log("redirect to checkout");
          recheckCartItems(true);
        });
      });
    }
});

function addPDPToCart(btn){
  let variant = parseInt(btn.dataset.variantId);
  console.log("variant:",variant);
  let formItems =[
    {
      'id': variant,
      'quantity': 1
    }
  ];
  let formData = {
    'items': formItems
  };
  console.log("formData: ",formData);
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(product => {
    if (product.status === 422){
      return;
    }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: product,
        addToCartBtn: btn
      }
    }));

  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Handle shakerChoice A/B test
function handleShakerChoiceTest() {
  console.log("window.shaker_choice:",window.shaker_choice);
  if(document.querySelector("shakerChoiceWrapper") != null){
    if(window.shaker_choice == "false"){
      document.querySelector("shakerChoiceWrapper").remove();
    }else{
      document.querySelector("shakerChoiceWrapper").style.display = "flex";
    }
  }
}

function handleBundleError(){
  if(document.querySelector("#bundleErrorAttribute") != null){
    theme.cart.updateAttribute("Bundle Error", "YES"); 
    // console.log("add bundle error");
  } else{
    theme.cart.updateAttribute("Bundle Error", ""); 
    // console.log("remove bundle error");
  }
}

document.addEventListener('cart:final_update', function(e){
  console.log("cart:final_update");
  handleShakerChoiceTest();
  handleBundleError();
});

window.addEventListener('load', function(e){
console.log("shakerchoice",document.querySelector("shakerChoiceWrapper"));
if(document.querySelector("shakerChoiceWrapper") != null){
  handleShakerChoiceTest();   
}
});